<template>
  <v-row class="px-0 py-3 ma-0 hot-jobs-empty">
    <v-col
      align-self="center"
      cols="12"
      sm="7"
      :class="$vuetify.breakpoint.xs ? 'pb-0' : null"
    >
      <p class="display-24 mb-0 lightBlack--text font-weight-medium">
        מעוניינים להוסיף כאן משרה משלכם?
      </p>
    </v-col>
    <v-col cols="12" sm="5" class="btn-job">
      <v-btn
        rounded
        color="primary"
        class="mb-2 job-btn font-weight-medium"
        :class="$vuetify.breakpoint.xs ? 'mt-0 ' : 'mt-3 '"
        :href="`${adminUrl}`"
      >
        צרו איתנו קשר!
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {},

  props: {},

  computed: {
    adminUrl() {
      return process.env.adminUrl;
    },
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.hot-jobs-empty {
  background: #f6f7f9 url(~assets/img/banners/no_hot_jobs_banner-mob.png) top
    center no-repeat;

  height: 120px;

  @media only screen and (min-width: 600px) {
    background: #f6f7f9 url(~assets/img/banners/no_hot_jobs_banner.png) top left
      no-repeat;
    height: 105px;
  }
}
p {
  text-align: center;
  @media only screen and (min-width: 800px) {
    text-align: left;
  }
}
.btn-job {
  text-align: center;
  @media only screen and (min-width: 800px) {
    text-align: right;
  }
}
</style>
